
import { makeUUID } from '$lib/factories'

import { SetOpenaiThreadItem } from '../openai_thread_item/manager'
import { type OpenaiThreadItem } from '../openai_thread_item/types'
import { openai_thread_items_store as store } from './openai_thread_items'


export async function OpenaiThreadItemAppendTokensToLastMessage(tokens: number) {
	
	let lastItem: OpenaiThreadItem | null = null
	store.update((prev) => {
		lastItem = prev[prev.length - 1]
		if (!lastItem) return prev
		lastItem.tokens += tokens
		return [...prev.slice(0, -1), lastItem]
	})

	// ==== upsert item ===========
	SetOpenaiThreadItem(lastItem)
	
}


export async function OpenaiThreadItemAppendToLastMessage(text: string) {
	
	let lastItem: OpenaiThreadItem | null = null
	store.update((prev) => {
		lastItem = prev[prev.length - 1]
		if (!lastItem) return prev
		lastItem.response += text
		return [...prev.slice(0, -1), lastItem]
	})

	
	// ==== upsert item ===========
	SetOpenaiThreadItem(lastItem)

}

export async function OpenaiThreadItemAppend(openaiThreadItem: OpenaiThreadItem) {

	if (!openaiThreadItem.id) {
		openaiThreadItem.id = makeUUID()
	}

	store.update((prev) => [...prev, openaiThreadItem])

	// ==== upsert item ===========
	SetOpenaiThreadItem(openaiThreadItem)
}


